import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  onClick
}: ButtonProps) {
  const sharedClasses = `
    relative overflow-hidden group inline-block cursor-pointer
    bg-gold text-dark-900 font-semibold py-4 px-8 rounded-sm
    shadow-[0_0_15px_rgba(212,175,55,0.3)]
    hover:shadow-[0_0_25px_rgba(212,175,55,0.5)]
    transition-all duration-300 ease-out no-underline
    ${className}
  `;
  const innerContent = <>
      <span className="relative z-10 flex items-center justify-center gap-2 text-lg md:text-xl" data-id="element-193">
        {children}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-194" />
    </>;
  if (onClick) {
    return <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={sharedClasses} data-id="element-195">
        {innerContent}
      </motion.button>;
  }
  return <motion.a href={href || 'https://equilibriazone.com/cart/52131674915099:1'} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={sharedClasses} data-id="element-196">
      {innerContent}
    </motion.a>;
}